import Model, { attr, hasMany } from '@ember-data/model';

export default class VfPerfilModel extends Model {
  @attr('string') codigo;

  @attr('string') nombre;

  @attr('boolean') activo;

  @attr('boolean') esSuperAdmin;

  @hasMany('menu', { async: false, inverse: null }) menus;

  @hasMany('permiso', { async: false, inverse: null }) permisos;

  get activoFormatted() {
    return this.activo ? 'Sí' : 'No';
  }
}
